const STORAGE_KEY = 'tw_cta_attribution';

export type Attribution = {
  cta_text: string;
  cta_location: string;
  cta_page: string;
  timestamp: number;
};

const isBrowser = typeof window !== 'undefined';

export function setAttribution(data: Omit<Attribution, 'timestamp'>) {
  if (!isBrowser) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...data, timestamp: Date.now() }),
    );
  } catch {}
}

export function getAttribution(): Attribution | null {
  if (!isBrowser) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Attribution) : null;
  } catch {
    return null;
  }
}

export function clearAttribution() {
  if (!isBrowser) return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
}
